export class SchoolInformationview {
        id: number=0;
        schoolName: string="";
        schoolEmail: string="";
        schoolNumber: string;
        schoolOwnerId: string;
        schoolSubdomain: string;
        schoolDescription: string;
        studentsCanEnrollForModules: boolean=false;
        studentsCanEnrollForPackages: boolean = false;
        tutorCanSendMail: boolean = false;
        privateSchool: boolean=false;
        logoImg: string="";
        appLogoImg: string="";
        invoiceEmail: string = "";
        // billingEmail:string;
        // billingName:string;
        // billingPhone:string;
        // billingAddress:string;
        accountTierId:number;
        stripeAccountId: string;
        bankId: number;
        accountName: string;
        accountNumber: string;
        hideFeesForFreeCourses: boolean = false;
        freePlanSelected: boolean = false;
        subdomain: string = "";
        timeZone:number;
        timeZoneName:string;
}
